var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenBookBlueIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 34,
    viewBox: "0 0 36 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.889 3.61091L30.889 3.6109C30.1188 2.84062 29.0955 2.42743 27.517 2.21521C25.9242 2.00106 23.8425 2 21 2H15C12.1574 2 10.0758 2.00106 8.48299 2.21521C6.90456 2.42743 5.88121 2.84061 5.11091 3.61091C5.11091 3.61091 5.11091 3.61091 5.11091 3.61091M30.889 3.61091L5.11091 3.61091M30.889 3.61091C31.6594 4.38121 32.0726 5.40456 32.2848 6.98299C32.4989 8.57581 32.5 10.6574 32.5 13.5V19.5C32.5 22.3425 32.4989 24.4242 32.2848 26.017C32.0726 27.5955 31.6594 28.6188 30.8891 29.389L30.889 29.3891C30.1188 30.1594 29.0955 30.5726 27.517 30.7848C25.9242 30.9989 23.8425 31 21 31H15C12.1574 31 10.0758 30.9989 8.48299 30.7848C6.90456 30.5726 5.88121 30.1594 5.11091 29.389L5.1109 29.389C4.34062 28.6188 3.92743 27.5955 3.71521 26.017C3.50106 24.4242 3.5 22.3425 3.5 19.5V13.5C3.5 10.6574 3.50106 8.57581 3.71521 6.98299C3.92743 5.40456 4.34061 4.38121 5.11091 3.61091M30.889 3.61091L5.11091 3.61091",
    fill: "url(#paint0_linear_1957_1496)",
    stroke: "url(#paint1_linear_1957_1496)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M9 19.3662V11.2447C9 10.0087 9.99809 9.00106 11.2308 9.09132C11.9995 9.14761 12.8339 9.24337 13.5 9.40614C14.7358 9.7081 16.2765 10.4566 17.1969 10.9397C17.2144 10.9489 17.2321 10.9578 17.25 10.9664V23.5893C17.2462 23.5873 17.2425 23.5854 17.2389 23.5834C16.3239 23.1013 14.7548 22.3344 13.5 22.0278C12.8437 21.8674 12.0241 21.772 11.2649 21.7155C10.019 21.6226 9 20.6155 9 19.3662Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 23.5905C18.7537 23.5886 18.7575 23.5866 18.7611 23.5847C19.6761 23.1026 21.2451 22.3356 22.5 22.029C23.1562 21.8687 23.9759 21.7733 24.7352 21.7167C25.9811 21.6239 27 20.6168 27 19.3674V11.1785C27 9.96937 26.0429 8.97446 24.8352 9.03377C23.9108 9.07918 22.8606 9.18271 22.05 9.40741C20.9527 9.71156 19.6128 10.4266 18.7829 10.9069C18.7721 10.9132 18.7609 10.9193 18.75 10.9254V23.5905Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1957_1496",
    x1: 3,
    y1: 16.5,
    x2: 33,
    y2: 16.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#527FED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#275BDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1957_1496",
    x1: 3,
    y1: 16.5,
    x2: 33,
    y2: 16.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#527FED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#275BDD"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenBookBlueIcon);
export default __webpack_public_path__ + "static/media/open_book_blue_icon.a071bc9f087d05decc9dd16bf372fb86.svg";
export { ForwardRef as ReactComponent };